export default "__VITE_ASSET__nKTzIaHD__"